export default __webpack_public_path__ + "static/media/snd_00015.47e00254.mp4";